module.exports = __webpack_public_path__ + "static/media/two_marker_hover.beded478.svg";